import React from 'react'
import styled from 'styled-components'
import { SlBadge, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import { HelpIcon } from '@nominex/dex-uikit'
import { useTranslation } from 'contexts/Localization'
import { BaseStyledBadge } from './styles'

// TODO: gradient should be moved to tailwind config
const StyledSlBadge = styled(SlBadge)`
  ::part(base) {
    background: linear-gradient(128.65deg, #ff7426 -2.22%, #b100ce 91.69%);
    ${BaseStyledBadge}
  }
`

const MigrationBadge: React.FC = () => {
  const { t } = useTranslation()

  return (
    <SlTooltip
      content={t(
        'This farming pool was migrated to v2. Migrate your liquidity from v1 pool to v2 pool to keep getting farming rewards.',
      )}
      hoist
    >
      <StyledSlBadge pill>
        {t('Migration')}
        <HelpIcon height="10px" width="10px" ml="2px" />
      </StyledSlBadge>
    </SlTooltip>
  )
}

export default MigrationBadge
